import { render, staticRenderFns } from "./HeaderH1.vue?vue&type=template&id=49fd91a0&"
import script from "./HeaderH1.vue?vue&type=script&lang=js&"
export * from "./HeaderH1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports